import React from "react";

// Minimalist motorboat side-view logo (boat hull + small cabin + wave)
export const BoatLogo = ({ className = "", strokeColor = "currentColor" }) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* Cabin / windshield */}
    <path
      d="M12 12 L17 8 L22 12 Z"
      fill={strokeColor}
      opacity="0.95"
    />
    {/* Hull */}
    <path
      d="M5 14 L27 14 L23 20 L9 20 Z"
      fill={strokeColor}
    />
    {/* Wave below */}
    <path
      d="M3 24 Q7 22 11 24 T19 24 T27 24 T31 24"
      stroke={strokeColor}
      strokeWidth="1.8"
      strokeLinecap="round"
      fill="none"
      opacity="0.85"
    />
  </svg>
);

export default BoatLogo;
